import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function HealthCard({ name, icon, content, size }) {
  return (
    <div className="health__card">
      <FontAwesomeIcon icon={icon} size={size} />
      <h3 className="health-tips-subtitle">{name}</h3>
      <p>{content}</p>
    </div>
  );
}

export default HealthCard;
